import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=f5ab0c5c&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=f5ab0c5c&prod&lang=css"
import style1 from "./ProductsList.vue?vue&type=style&index=1&id=f5ab0c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ab0c5c",
  null
  
)

export default component.exports